import React, { useEffect } from 'react'
import ServicesCards from '../localData/ServicesData'
import ServCard from '../Components/ServCard';
import { useTranslation } from 'react-i18next';
import cookies from 'js-cookie';
import { Helmet } from 'react-helmet-async';


function SevrvicesPage() {
    const { t } = useTranslation();
    const servicesData = ServicesCards();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { i18n } = useTranslation();
    const lng = cookies.get('i18next') || '';

    useEffect(() => {
        const contactElement1 = document.querySelector('#sec-navbar');


        if (contactElement1) {
            const direction = i18n.dir();
            contactElement1.dir = direction;


        }
    }, [i18n, lng]);


    return (
        <div>
            <Helmet>
                <title>{t("servNav")}</title>
                <link rel="canonical" href="https://trendlineeg.com/services" />
                <meta name="description" content={t("servNav")} />
                <meta name="keywords" content={t("servNav")} />
                <meta property="og:image" content="https://trendlineeg.com/showCase.jpg" />
                <meta property="og:title" content={`TrendLine ${t("servNav")}`} />
                <meta property="og:url" content="https://trendlineeg.com/services" />
                <meta property="og:description" lang="ar"
                    content="شركة ترندلاين متخصصة في تقديم حلول منخفضة التيار المتكاملة بما في ذلك أنظمة المراقبة بالفيديو عالية الدقة، وأنظمة التحكم في الوصول، وأنظمة الإنذار بالحريق، وأنظمة الأمان، والخوادم ووحدات التخزين الشبكية، وجدران الحماية، واللاب توب وأجهزة الكمبيوتر، وقطع الكمبيوتر، والشاشات والتلفزيونات، والشاشات التفاعلية، والألياف البصرية وUTP، وحلول WiMax وUbiquiti. تقدم الشركة خدمات البيع المباشر، التوصيل، التركيب، والبرمجة لعملاء الإلكترونيات، اللاب توب، السيرفرات، الكمبيوترات التجميع، السمارت هوم، جدران الحماية، أنظمة المراقبة، إدارة المحال التجارية، إدارة الفنادق، التوصيل الشبكي بالكابل، الواي فاي، الفايبر أوبتيكال، خدمة العملاء، السنترال الداخلي، ربط الفروع، الفيديو كول، الإنتركوم المرئي والصوتي، الساوند المركزي، الدش والستالايت، وأنظمة الألواح الشمسية" />
                <meta property="og:description" lang="en"
                    content="Trendline specializes in providing integrated low current solutions, including HD video surveillance, access control systems, fire alarm systems, security systems, servers and NAS storage, firewalls, laptops and PCs, PC hardware, monitors and TVs, interactive screens, fiber optics and UTP, and WiMax and Ubiquiti solutions. The company offers direct sales, delivery, installation, and programming services for electronics, laptops, servers, custom-built computers, smart home, firewalls, surveillance systems, retail management, hotel management, wired, Wi-Fi, and fiber optic network solutions, customer service systems, internal PBX, branch connectivity, video call systems, intercom (video and audio), central sound systems, satellite dishes, and solar panels." />
            </Helmet>
            <section className='servicesP'>
                <div className='sectionH'>
                    <h2><span>{t("servNav")}</span></h2>
                </div>
                <div className='container-'>
                    <ServCard servicesData={servicesData} />
                </div>
            </section>
        </div>
    )
}

export default SevrvicesPage